app.service('expandingCheckbox',function(){
	var $checkbox, $expand;
	
	function setElements(){
		$checkbox = $('.js-expanding-checkbox');
		$expand = $('.js-expand', $checkbox);
	}
	
	function setEvents(){
		$expand.on('click',function(){
			var $current = $(this).closest('.js-expanding-checkbox');
			if ($current.hasClass('expanded')){
				$current.removeClass('expanded');
			}
			else{
				$current.addClass('expanded');
			}
		});
	}

	function init(){
		setElements();
		setEvents();
	}

	return {
		init:init
	};
});
